import InvoiceManagmentGateway from "@/usecases/accounting/invoice-management-gateway";
import InvoiceManagment from "@/usecases/accounting/invoice-management";
import SaveInvoiceManagementRequest from "@/usecases/accounting/save-invoice-management-request";
import ClientLike from "../client-like";
import invoiceStatusTranslater from "@/usecases/accounting/invoice-status-translater";

export default class InvoiceManagementApi implements InvoiceManagmentGateway {
  public constructor(private client: ClientLike) {}

  public async find(id: number): Promise<InvoiceManagment | undefined> {
    const res = await this.client.get("get_invoice_management.php", { id });
    if (res.invoices.length > 0) {
      return toInvoice(res.invoices[0]);
    }
  }

  public async findAll(
    options: {
      projectId?: string;
      projectName?: string;
      companyId?: string;
      status?: string;
      startDate?: string;
      endDate?: string;
    } = {}
  ): Promise<InvoiceManagment[]> {
    const res = await this.client.get("get_invoice_management.php", options);
    return res.invoices.map(toInvoice);
  }

  public async save(invoice: SaveInvoiceManagementRequest): Promise<number> {
    const data = await this.client.post("save_invoice_management.php", invoice);
    return data.id;
  }

  public async destroy(id: number): Promise<void> {
    const d = new FormData();
    d.append("id", String(id));
    await this.client.post("delete_invoice.php", d);
  }
}

function toInvoice(data: any): InvoiceManagment {
  return {
    ...data,
    statusName: invoiceStatusTranslater.toJp(data.status)
  };
}
